import { Component, OnInit, Inject } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { TranslateService } from '@ngx-translate/core';
import {
  ActivatedRoute,
  RoutesRecognized,
  Params,
  Router
} from '@angular/router';

@Component({
  selector: 'home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
  standalone: false
})
export class HomeComponent implements OnInit {
  public noAccess: boolean = false;
  public techError: boolean = false;

  constructor(
    private translate: TranslateService,
    // logger removed, use console instead
    private logger: NGXLogger,
    private router: Router
  ) { }

  public ngOnInit() {
    this.logger.info('Home Component');
    this.logger.log('Loading HomeComponent');


    const userStr = sessionStorage.getItem('user');
    if (!userStr) {
      this.techError = true;
      this.logger.info('End Home Component');
      return;
    }

    try {
      const userProfile = JSON.parse(userStr);
      if (userProfile && userProfile.security && userProfile.security.officeTab) {
        this.logger.log('HomeComponent: Office Permission');
        this.router.navigate(['/office']);
      } else if (userProfile && userProfile.security
        && userProfile.security.terminalAndPrinterTab) {
        this.logger.log('HomeComponent: terminalAndPrinterTab Permission');
        this.router.navigate(['/tpa']);
      } else if (userProfile && userProfile.security &&
        (userProfile.security.vendorSettingTab ||
          userProfile.security.systemDataTab ||
          userProfile.security.configurationTab)) {
        this.logger.log('HomeComponent: configurationTab Permission');
        this.router.navigate(['/settings']);
      } else if (userProfile && userProfile.security && userProfile.security.historyTab) {
        this.router.navigate(['/history']);
      } else if (userProfile && userProfile.security && userProfile.security.massiveTabVisible) {
        this.router.navigate(['/massive-actions']);
      } else if (userProfile && userProfile.security && userProfile.security.massDeviceTabVisible) {
        this.router.navigate(['/massive-actions']);
      } else {
        this.logger.log('HomeComponent: NO permission');
        // Display appropriate message based on result
        if (userProfile && userProfile.security) {
          this.noAccess = true;
        } else {
          this.techError = true;
        }
      }
    } catch (error) {
      this.logger.error('Error parsing user profile in HomeComponent:', error);
      this.techError = true;
    }
    console.groupEnd();
  }

  public login() {
    this.router.navigate(['/login']);
  }

}